import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';

import storage from 'utils/storageController';

type Auth = {
    auth: boolean;
    role: string;
};

export function useAuth(): Auth {
    const role = storage.getUserRole();
    // const role = store.getState().user.entity.role;

    if (role) {
        return {
            auth: true,
            role: role,
        };
    } else {
        return {
            auth: false,
            role: '',
        };
    }
}

export default function ProtectedRoute({ allowedRoles }: { allowedRoles?: string[] }) {
    const { auth, role } = useAuth();
    const location = useLocation();
    const outletContext = useOutletContext<unknown>();

    if (allowedRoles) {
        return auth ? (
            allowedRoles.includes(role) ? (
                <Outlet context={outletContext} />
            ) : (
                <Navigate to="/unauthorized" state={{ from: location }} replace />
            )
        ) : (
            <Navigate to="/login" state={{ from: location }} replace />
        );
    } else
        return auth ? (
            <Outlet context={outletContext} />
        ) : (
            <Navigate to="/login" state={{ from: location }} replace />
        );
}
